import { studentsControllerSaveAinaEvents } from "@oneapp/data";
import { AINA_EVENT_WIDGET_OPEN } from "@repo/utils";

/**
 * Fire-and-forget: POST /students/aina-events when the user opens AINA from the widget
 * (floating icon, bottom nav, or equivalent). Authorization via API client interceptors.
 */
export function sendAinaWidgetOpenEvent(): void {
  void studentsControllerSaveAinaEvents(
    { eventType: AINA_EVENT_WIDGET_OPEN },
    {
      clientName: "oneApp",
      headers: { "x-platform": "web" },
    },
  ).catch(() => {
    /* analytics — ignore */
  });
}
